import { render, staticRenderFns } from "./editForm.vue?vue&type=template&id=dd48e344&scoped=true&"
import script from "./editForm.vue?vue&type=script&lang=js&"
export * from "./editForm.vue?vue&type=script&lang=js&"
import style0 from "./editForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./editForm.vue?vue&type=style&index=1&id=dd48e344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd48e344",
  null
  
)

component.options.__file = "editForm.vue"
export default component.exports